import { Text, StackChildren } from '@doordash/design-language'
import { FeatureFlag } from '@doordash/lib-feature-flags'
import { CountryCode } from '@doordash/lib-i18n'
import * as React from 'react'

import {
  CANADA_HELP_URL,
  COUNTRY_SHORTCODES,
  VehicleType,
} from '../../../constants'

import { SignUpDetailsText } from './constants'
import t from './strings'
import { Link } from './styles'
import { TextType } from '../../atoms/text-section/text-section'
import TextSection from '../../atoms/text-section'

type WhatToBringManagerProps = {
  countryCode: CountryCode
  vehicleType?: string
}

const mapVehicleToState = vehicleType => {
  switch (vehicleType) {
    case VehicleType.Bicycle:
      return [0]
    case VehicleType.Scooter:
      return [1]
    case VehicleType.Motorcycle:
      return [2]
    case VehicleType.Car:
      return [3]
    default:
      return []
  }
}

export const WhatToBringManager: React.FC<WhatToBringManagerProps> = ({
  countryCode,
  vehicleType,
}) => {
  if (countryCode == COUNTRY_SHORTCODES.JP) {
    return (
      <React.Fragment>
        <TextSection
          title={''}
          type={TextType.List}
          text={SignUpDetailsText}
          disableDesktopWidth={true}
          initialState={mapVehicleToState(vehicleType)}
          style={{ minWidth: '100%' }}
        />
      </React.Fragment>
    )
  }
  return (
    <React.Fragment>
      <Text styles={Text.Styles.Caps16}>{t.whatToBring()}</Text>
      <StackChildren>
        <Text>• {t.whatToBringOne()}</Text>
        {(() => {
          switch (countryCode) {
            case COUNTRY_SHORTCODES.AU:
              return (
                <Text>
                  • {t.ausWhatToBringTwo()}
                  <Link
                    // tslint:disable-next-line:max-line-length
                    href="https://www.nationalcrimecheck.com.au/files/695_id.pdf"
                    target="_blank"
                  >
                    {t.ausIdLink()}
                  </Link>
                </Text>
              )
            case 'PR':
              return <Text>• {t.prWhatToBringTwo()}</Text>
            default:
              return (
                <Text>
                  • {t.whatToBringTwo()}
                  <FeatureFlag
                    on={() => (
                      <span>
                        {` ${t.or()} `}
                        <a href={CANADA_HELP_URL}>{t.whatToBringTwoAlt()}</a>
                      </span>
                    )}
                    flagName="canadaBgcOutOfBand"
                  />
                </Text>
              )
          }
        })()}
        <Text>• {t.whatToBringThree()}</Text>
      </StackChildren>
    </React.Fragment>
  )
}

export default WhatToBringManager
